import { Check, X, TrendingUp } from 'lucide-react'
import CollapsibleSection from './CollapsibleSection'
import type { CustomerJourney } from './types'

interface CustomerJourneyCardProps {
  journey: CustomerJourney
}

const JOURNEY_STEPS: Array<{ key: keyof CustomerJourney; label: string }> = [
  { key: 'opportunity', label: 'Oportunidade' },
  { key: 'did_presentation', label: 'Fez apresentação' },
  { key: 'signed_up', label: 'Se cadastrou' },
  { key: 'paying_customer', label: 'Virou cliente pagante' },
  { key: 'engaged', label: 'Engajado' },
]

export default function CustomerJourneyCard({ journey }: CustomerJourneyCardProps) {
  const completedCount = JOURNEY_STEPS.filter((step) => journey[step.key]).length

  return (
    <CollapsibleSection
      title="Jornada"
      icon={TrendingUp}
      defaultOpen
      summary={`${completedCount}/${JOURNEY_STEPS.length}`}
    >
      <ul className="space-y-2">
        {JOURNEY_STEPS.map((step) => {
          const completed = journey[step.key]
          const StatusIcon = completed ? Check : X
          return (
            <li key={step.key} className="flex items-center gap-2 text-sm">
              <div className={`w-5 h-5 rounded-full flex items-center justify-center shrink-0 ${
                completed ? 'bg-green-100' : 'bg-red-100'
              }`}>
                <StatusIcon className={`w-3 h-3 ${completed ? 'text-green-600' : 'text-red-500'}`} />
              </div>
              <span className={completed ? 'text-gray-700' : 'text-gray-400'}>
                {step.label}
              </span>
            </li>
          )
        })}
      </ul>
    </CollapsibleSection>
  )
}
